var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMentorshipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2969 29.8728C37.5579 28.7972 38.3597 27.1985 38.3597 25.415C38.3597 22.1842 35.7312 19.5557 32.5004 19.5557C29.6707 19.5557 27.3033 21.5719 26.7589 24.2432H21.9535V23.0713C21.9535 19.92 20.1501 17.1786 17.5122 15.8052C18.8678 14.6615 19.6097 13.0557 19.6097 11.3525C19.6097 8.11324 16.9117 5.49316 13.6722 5.49316C10.4329 5.49316 7.73474 8.11309 7.73474 11.3525C7.73474 13.052 8.4738 14.659 9.83232 15.8052C7.19443 17.1786 5.39099 19.92 5.39099 23.0713V24.2432H4.21912C2.2806 24.2432 0.703491 25.8203 0.703491 27.7588C0.703491 29.2865 1.68326 30.5891 3.04724 31.0729V39.6338C3.04724 40.281 3.57193 40.8057 4.21912 40.8057C4.87044 40.8057 39.0587 40.8057 39.5316 40.8057C40.1788 40.8057 40.7035 40.281 40.7035 39.6338V37.2119C40.7035 34.0277 38.9138 31.258 36.2969 29.8728ZM32.5004 21.8994C34.4389 21.8994 36.016 23.4765 36.016 25.415C36.016 27.3536 34.4389 28.9307 32.5004 28.9307C30.5619 28.9307 28.9847 27.3536 28.9847 25.415C28.9847 23.4765 30.5619 21.8994 32.5004 21.8994ZM13.6722 7.83691C15.6203 7.83691 17.266 9.44684 17.266 11.3525C17.266 13.2582 15.6203 14.8682 13.6722 14.8682C11.7242 14.8682 10.0785 13.2582 10.0785 11.3525C10.0785 9.44684 11.7242 7.83691 13.6722 7.83691ZM7.73474 23.0713C7.73474 19.8404 10.3983 17.2119 13.6722 17.2119C16.9461 17.2119 19.6097 19.8404 19.6097 23.0713V24.2432H7.73474V23.0713ZM3.04724 27.7588C3.04724 27.1126 3.57294 26.5869 4.21912 26.5869C4.42951 26.5869 26.5941 26.5869 26.7589 26.5869C26.9353 27.4525 27.3032 28.2489 27.8161 28.9307H4.21912C3.57294 28.9307 3.04724 28.405 3.04724 27.7588ZM24.2972 38.4619H5.39099V31.2744H26.7883C25.2529 32.7802 24.2972 34.8854 24.2972 37.2119V38.4619ZM38.3597 38.4619H26.641V37.2119C26.641 33.9379 29.2695 31.2744 32.5004 31.2744C35.7312 31.2744 38.3597 33.9379 38.3597 37.2119V38.4619Z",
    fill: "url(#paint0_linear_1_174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8441 5.49316H27.8129C27.1657 5.49316 26.641 6.01785 26.641 6.66504C26.641 7.31223 27.1657 7.83691 27.8129 7.83691H34.8441C35.4913 7.83691 36.016 7.31223 36.016 6.66504C36.016 6.01785 35.4913 5.49316 34.8441 5.49316Z",
    fill: "url(#paint1_linear_1_174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1879 0.805664H25.4691C23.5306 0.805664 21.9535 2.38277 21.9535 4.32129V9.00879C21.9535 10.5366 22.9331 11.84 24.2972 12.3236V16.04C24.2972 16.514 24.5827 16.9414 25.0207 17.1227C25.4586 17.3041 25.9626 17.2038 26.2978 16.8686L30.642 12.5244H37.1879C39.1264 12.5244 40.7035 10.9473 40.7035 9.00879V4.32129C40.7035 2.38277 39.1264 0.805664 37.1879 0.805664ZM38.3597 9.00879C38.3597 9.65496 37.834 10.1807 37.1879 10.1807H30.1566C29.8458 10.1807 29.5477 10.3042 29.328 10.5239L26.641 13.2109V11.3525C26.641 10.7054 26.1163 10.1807 25.4691 10.1807C24.8229 10.1807 24.2972 9.65496 24.2972 9.00879V4.32129C24.2972 3.67512 24.8229 3.14941 25.4691 3.14941H37.1879C37.834 3.14941 38.3597 3.67512 38.3597 4.32129V9.00879Z",
    fill: "url(#paint2_linear_1_174)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_174",
    x1: 20.7035,
    y1: 5.49316,
    x2: 20.7035,
    y2: 40.8057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FED2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_174",
    x1: 31.3285,
    y1: 5.49316,
    x2: 31.3285,
    y2: 7.83691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FED2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_174",
    x1: 31.3285,
    y1: 0.805664,
    x2: 31.3285,
    y2: 17.2119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FED2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30707"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.703491 0.805664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorshipIcon);
export default __webpack_public_path__ + "static/media/mentorshipIcon.8048520c423e60867769178b3b9582ba.svg";
export { ForwardRef as ReactComponent };